import { render } from "./xiangcun-news.vue?vue&type=template&id=618833ac&scoped=true"
import script from "./xiangcun-news.vue?vue&type=script&lang=js"
export * from "./xiangcun-news.vue?vue&type=script&lang=js"

import "./xiangcun-news.vue?vue&type=style&index=0&id=618833ac&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618833ac"]])

export default __exports__